<!-- <router-outlet></router-outlet> -->
<div id="all" class="" *ngIf="datas" (touchstart)="onClick($event)" (click)="onClick($event)">
  <div *ngIf="currentVideo" id="video" class="" (touchstart)="onVideoClick($event)" (click)="onVideoClick($event)">
    <video #video autoplay [attr.muted]="loop ? '' : null" [attr.loop]="loop ? 'loop' : null" [src]="this.base+this.datasName+'/videos/'+currentVideo" (ended)="onVideoEnded($event)"></video>
    <!-- <video #video autoplay [src]="base+datasName+'/files/'+datas.video" class="fullHD" [poster]="base+'files/'+getPoster(datas.video)" (ended)="onVideoEnded($event)"></video> -->
    <div class="progressBar" *ngIf="!loop">
      <div class="progressingBar" [style.backgroundColor]="datas.secondary_color" [style.height]="videoProgress+'%'"></div>
    </div>
  </div>
  
  <div id="splash" class="page roboto fullHD" *ngIf="current == 'splash'" (touchstart)="onSplashClick($event)" (click)="onSplashClick($event)">
    
    <div class="languages suburban" *ngIf="datas.questions_en.length != 0">
      <a *ngFor="let item of languages; let i=index;" (touchstart)="onLang($event, i)" (click)="onLang($event, i)" [innerHTML]="item.language" [class]="item.language" [class.off]="item.language != lang" [style.backgroundColor]="espace?.color"></a>
    </div>
  </div>
  
  <div id="visio" class="page roboto fullHD" *ngIf="current == 'visio'">
    <!-- <div class="header">
      <p class="date" [innerHTML]="date"></p>
      <p class="logs">
        <span class="connexion">
          <span class="col">
            <ng-container *ngIf="lang=='fr'">Connexion</ng-container>
            <ng-container *ngIf="lang=='en'">Connection</ng-container>
          </span>
          <span class="col">
            <span class="time" [innerHTML]="time"></span>
          </span>
        </span><br>
        <span class="person" [innerHTML]="datas['person'+suffix]">...</span><br>
        <span class="labo" [innerHTML]="datas['labo'+suffix]">...</span><br>
        <span class="place" [innerHTML]="datas['lieu'+suffix]">...</span>
      </p>
    </div> -->
    <div class="presentation" *ngIf="loop">
      Bonjour, <br>
      Je m'appelle <b>Catherine Lenne</b>. <br>
      Je suis chercheure en biologie végétale. <br>
      Choisis une question et je te répondrai.
    </div>
    <div class="questions">
      <!-- <p class="title">Posez vos questions :</p> -->
      <ol>
        <li *ngFor="let question of datas['questions'+suffix]; let i = index;" [class.on]="i == selected" [class.off]="i !== selected && !askedQuestions.includes(i)" [class.asked]="i !== selected && askedQuestions.includes(i)" ><a (touchstart)="onClickQuestion($event, i)" (click)="onClickQuestion($event, i)" [innerHTML]="question.question" [style.backgroundColor]="datas.secondary_color">...</a></li>
      </ol>
    </div>
    <!-- <div class="footer">
      <span class="btn-call" *ngIf="espace" [style.backgroundColor]="espace.color" (touchstart)="onHang($event)" (click)="onHang($event)">
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-telephone-inbound-fill" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zM15.854.146a.5.5 0 0 1 0 .708L11.707 5H14.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.793L15.146.146a.5.5 0 0 1 .708 0z"/>
        </svg>
      </span>
    </div> -->
    <div id="debug" [innerHTML]="debugTxt" *ngIf="debug"></div>
  </div>
</div>
